const DESKTOP_QUERY = '(min-width: 990px)';

// Desktop dropdowns are single-open: opening one closes the others (QI TSK-81731).
// They are absolutely-positioned overlays sitting side by side, so two open at once
// overlap each other and cover the grid behind them.
//
// The mobile drawer keeps them independent. There the groups are accordions in normal
// flow that push content down rather than overlapping, so several open at once is both
// harmless and useful — you can set availability and price without reopening either.
//
// Clicks are delegated on the root instead of bound per-toggle: CollectionInfo's fetch
// pipeline replaces individual filter groups' innerHTML by id on every filter/sort
// change, so any listener attached directly to a toggle button goes stale on the next
// fetch. Delegation and a live groups getter keep this working regardless of what gets
// swapped underneath.
if (!customElements.get('collection-filters')) {
  customElements.define(
    'collection-filters',
    class CollectionFilters extends HTMLElement {
      connectedCallback() {
        this.desktop = window.matchMedia(DESKTOP_QUERY);

        this.onClick = this.onClick.bind(this);
        this.onOutsideClick = this.onOutsideClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onBreakpointChange = this.onBreakpointChange.bind(this);

        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        document.addEventListener('click', this.onOutsideClick);
        this.desktop.addEventListener('change', this.onBreakpointChange);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onOutsideClick);
        this.desktop.removeEventListener('change', this.onBreakpointChange);
      }

      get groups() {
        return Array.from(this.querySelectorAll('[data-filter-group]'));
      }

      onBreakpointChange() {
        this.closeAllGroups();
      }

      onClick(event) {
        const toggle = event.target.closest('[data-filter-toggle]');
        if (!toggle) { return; }

        const group = toggle.closest('[data-filter-group]');
        const isOpen = !group.classList.contains('is-open');

        if (isOpen && this.desktop.matches) {
          this.closeAllGroups();
        }

        this.setGroupOpen(group, isOpen);
      }

      onOutsideClick(event) {
        if (!this.desktop.matches || this.contains(event.target)) { return; }
        this.closeAllGroups();
      }

      onKeydown(event) {
        if (event.key !== 'Escape') { return; }

        const openGroup = this.desktop.matches && this.groups.find((group) => group.classList.contains('is-open'));
        if (openGroup) {
          this.setGroupOpen(openGroup, false);
          openGroup.querySelector('[data-filter-toggle]').focus();
          return;
        }

        if (this.classList.contains('cfilters--open')) {
          this.querySelector('.cfilters__panel-close').click();
          this.querySelector('.cfilters__trigger').focus();
        }
      }

      setGroupOpen(group, isOpen) {
        group.classList.toggle('is-open', isOpen);
        group.querySelector('[data-filter-toggle]').setAttribute('aria-expanded', isOpen.toString());
      }

      closeAllGroups() {
        for (const group of this.groups) {
          this.setGroupOpen(group, false);
        }
      }
    },
  );
}
